import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, LabelList } from "recharts";
import { fmtRupiah } from "@/lib/api";
import { DEPT_PALETTE } from "@/components/DeptBar";

const TooltipStyle = { background: "#0B132B", border: "1px solid #334155", borderRadius: 10, color: "#F8FAFC", fontSize: 12 };
const short = (v) => (v >= 1e9 ? `${(v / 1e9).toFixed(2)} M` : v >= 1e6 ? `${Math.round(v / 1e6)} jt` : `${Math.round(v / 1e3)} rb`);

export const DeptAmountChart = ({ data }) => {
  const grand = data.reduce((s, d) => s + (d.shared_amount || 0), 0);
  return (
    <div data-testid="dept-amount-chart" className="rounded-xl border border-slate-700/60 bg-[#111D38]/70 backdrop-blur-md p-5 h-full">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-slate-100 font-semibold text-base">TOTAL PO SHARED BY DEPARTEMENT</h3>
        <span data-testid="dept-amount-grand-total" className="text-xs font-mono text-emerald-300 font-semibold">{fmtRupiah(grand)}</span>
      </div>
      <div className="h-72">
        <ResponsiveContainer>
          <BarChart data={data} margin={{ left: 8, right: 16, top: 24, bottom: 4 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1F2A44" vertical={false} />
            <XAxis dataKey="name" stroke="#94A3B8" fontSize={11} />
            <YAxis stroke="#94A3B8" fontSize={11} tickFormatter={short} width={60} />
            <Tooltip contentStyle={TooltipStyle} itemStyle={{ color: "#6EE7B7" }} labelStyle={{ color: "#F8FAFC", fontWeight: 600 }} cursor={{ fill: "rgba(245,158,11,0.08)" }}
              formatter={(v, n, p) => [`${fmtRupiah(v)} (${p.payload.shared_count} PO)`, "Total PO Shared"]} />
            <Bar dataKey="shared_amount" radius={[8, 8, 0, 0]}>
              {data.map((d, i) => <Cell key={d.name} fill={DEPT_PALETTE[i % DEPT_PALETTE.length]} />)}
              <LabelList dataKey="shared_amount" position="top" formatter={short} fill="#E2E8F0" fontSize={11} fontWeight={700} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
